module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-500-de8b7431b74642e830af4d4f4b513ec9.woff";